import { render } from "./HeaderAddPatient.vue?vue&type=template&id=5b738756"
import script from "./HeaderAddPatient.vue?vue&type=script&lang=js"
export * from "./HeaderAddPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__